import React from "react";
import { Flex } from "../../components/Flex";
import { Content } from "../../components/Layout";
import { Title } from "../../components/Text";
import { ShcDashboard } from "./ShcDashboard";
import { ShcNode } from "./ShcNode";

import { ShcFile } from "./ShcFile";
import { Breadcrumbs } from "../../components/Breadcrumbs";
import { Link } from "react-router-dom";
import { ShcEmpty } from "./ShcEmpty";


const Shc = ({
    node,
    nodes=[],
    dates,
    data,
    pathname,
    onlyFailed,
    showOnlyFailed,
    interval,
    onDateChange,
    onSwitchMode,
    showFiles,
    file,
    result,
    showPassed,
    onShowPassed,
    breadcrumbs,
    dashboard,
    onChartBarClick,
    onShowRule,
    upload,
    uploadFile,
    shcRead,
    notFound
}) => {
    let content = null;

    if (file) {
        content = <ShcFile
            {...result}
            file={upload}
            loading={result === null}
            showPassed={showPassed}
            onShowPassed={onShowPassed}
            onShowRule={onShowRule}
            notFound={notFound}
        />
    } else if (node) {
        content = <ShcNode
            node={node}
            data={data}
            dates={dates}
            interval={interval}
            showFiles={showFiles}
            onlyFailed={onlyFailed}
            loading={data === null}
            onDateChange={onDateChange}
            onSwitchMode={onSwitchMode}
            showOnlyFailed={showOnlyFailed}
            pathname={pathname + "/" + node.toLowerCase()}
            onChartBarClick={onChartBarClick}
            notFound={notFound}
        />
    } else if (Array.isArray(nodes) && nodes.length || !Array.isArray(data)) {
        content = <ShcDashboard
            nodes={nodes}
            data={data}
            pathname={pathname}
            onlyFailed={onlyFailed}
            onChartBarClick={onChartBarClick}
        />
    } else if (shcRead === true) {
        content = <ShcEmpty uploadFile={uploadFile} />
    };

    return(
        <Content padding={dashboard ? { top: "24px", right: "17px", bottom: "33px", left: "42px" } : null}>
            <Flex justify="space-between" align="center" padding={dashboard ? { right: "23px"} : null }>
                <Title h4 capitalize={!node} nowrap>
                    <Breadcrumbs items={breadcrumbs} />
                </Title>
                {node
                    ? null
                    : <Link to={{pathname: "/services/shc/uploads", state: { from: null }}} style={{ fontSize: "14px" }}>
                        Uploaded SHC data
                    </Link>}
            </Flex>
            {content}
        </Content>
    )
}

export { Shc }